import React from "react";
import { useState, useEffect } from "react";
import "./order-details.css";
import ProgressTrackertwo from "../Progresstracker/ProgressTrackertwo";
import OrderSummary from "./OrderSummary";
import Cancelorderpopup from "./Cancelorderpopup";
import { useParams } from "react-router-dom";
import { apiurl } from "../../Constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../../features/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
function Trackingorder() {
  const [showpopup, setShowpopup] = useState(false);

  const user_id = localStorage.getItem("userId");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { order_id } = useParams();

  const { items: cartitems } = useSelector((state) => state.cartitems);

  const IsinCart = (product_id) => {
    return cartitems && cartitems.some((items) => items.id === product_id);
  };

  const handleclosePopup = () => {
    setShowpopup(false);
  };

  const [orderDetailslist, fetchOrderdetailslist] = useState({});

  useEffect(() => {
    const fetchOrderdetails = async () => {
      try {
        const response = await axios.post(apiurl + "order_details", {
          order_id: order_id,
        });
        fetchOrderdetailslist(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchOrderdetails();
  }, [order_id]);

  const handleAddtocart = (item) => {
    if (!user_id) {
      navigate("/login");
      return;
    }

    dispatch(addToCart({ user_id, product_id: item, quantity: 1 }))
      .then(() => {
        toast.success("✓", { autoClose: 2000, className: "custom-toast" });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className="tracking_order_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10 col-md-12 col-sm-12 order_summary_column">
            <div className="order_summary">
              <OrderSummary orderDetailslist={orderDetailslist} />
            </div>
          </div>
        </div>
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10 col-md-12 col-sm-12 ">
            <div className="order_details_prouduct_list_main_box order_details_prouduct_list  table-responsive">
              <table
                className="table"
                style={{ borderBottom: "1px solid transparent" }}
              >
                <tbody>
                  {orderDetailslist?.product_details?.length > 0
                    ? orderDetailslist.product_details.map((item, index) => {
                        return (
                          <tr>
                            <td
                              style={{
                                verticalAlign: "middle",
                              }}
                            >
                              <div className="inner-box">
                                <div className="img_box">
                                  <Link to={`/product-details/${item.slug}`}><img src={item.product_image[0]} alt="img" style={{width:'80px', height:'80px'}} /></Link>
                                </div>
                                <div className="content_box">
                                  <p className="mb-0"><Link to={`/product-details/${item.slug}`} style={{textDecoration:'none', color:'inherit'}}>{item.product_name}</Link></p>
                                  <div className="price_qty_box">
                                    {" "}
                                    <span>{item.quantity} Qty</span>
                                    <span>RM {item.total_price}</span>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td
                              style={{ verticalAlign: "middle" }}
                              className="text-end"
                            >
                              {IsinCart(item.product_id) ? (
                                <button
                                  className="btn_1_1"
                                  onClick={() => {
                                    navigate("/cart");
                                  }}
                                  style={{ textDecoration: "none" }}
                                >
                                  Go to Cart
                                </button>
                              ) : (
                                <button
                                  className="btn_1_1"
                                  onClick={() =>
                                    handleAddtocart(item.product_id)
                                  }
                                >
                                  Buy Again
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showpopup ? <Cancelorderpopup onClose={handleclosePopup} /> : null}
    </section>
  );
}

export default Trackingorder;
